import React from 'react';
import {
  Modal,
  Steps,
  Button,
  Checkbox,
  Alert,
  List,
  notification
} from 'antd';
import { listItems } from '../api';
const { Step } = Steps;

export default class extends React.Component {
  state = {
    step: 0,
    status: 'wait',
    errors: [],
    apiErrors: [],
    apiInfo: [],
    channelIds: []
  };

  onToggleChannel = (channel, e) => {
    this.setState(prevState => ({
      channelIds: prevState.channelIds
        .filter(id => id !== channel.id)
        .concat(e.target.checked ? channel.id : null)
        .filter(Boolean)
    }));
  };

  checkListings = async () => {
    this.setState({ step: 1, status: 'process' });

    const { selections } = this.props;
    const required = ['title', 'description', 'price', 'images'];

    const errors = selections.reduce((errors, item) => {
      const missing = required.filter(field => !item[field]);
      if (missing.length) {
        errors.push({ item, required: missing });
      }
      return errors;
    }, []);

    this.setState({ status: errors.length ? 'error' : 'finish', errors });
  };

  publishListings = async () => {
    const { selections, onClose } = this.props;
    const { channelIds } = this.state;
    const skus = selections.map(item => item.sku);

    this.setState({ step: 2, status: 'process' });

    try {
      const results = await Promise.all(
        channelIds.map(id => listItems(id, skus))
      );
      const apiInfo = [].concat(
        ...results.map(result => result.info).filter(Boolean)
      );
      const apiErrors = results
        .map(result => result.status)
        .filter(status => status !== 'OK');
      if (apiErrors.length) {
        const error = new Error('API Error');
        error.state = { apiInfo, apiErrors };
        throw error;
      }

      notification.success({ message: 'Listings published successfully' });
      this.setState({ status: 'finish', apiInfo });
    } catch (err) {
      console.error(err);
      this.setState({ status: 'error', ...(err.state || {}) });
      notification.error({ message: 'There were errors during publish' });
    }
  };

  render() {
    const { open, onClose, onComplete, channels } = this.props;
    const { step, status, errors, channelIds } = this.state;

    return (
      <Modal
        title="Publish Listings"
        footer={null}
        visible={open}
        onCancel={onClose}
        centered={true}
        width={720}
      >
        <Steps current={step}>
          <Step title="Select Marketplaces" />
          <Step title="Performing Checks" />
          <Step title="Publishing" />
        </Steps>
        <div className="current-step">
          {step === 0 && (
            <div>
              <p>
                Please select the marketplaces where your listings will be
                published.
              </p>
              {channels.map(channel => (
                <div key={channel.id}>
                  <Checkbox
                    checked={channelIds.includes(channel.id)}
                    onChange={e => this.onToggleChannel(channel, e)}
                  />
                  &nbsp;
                  {channel.name}
                </div>
              ))}
              <div className="current-step__buttons">
                <Button onClick={onClose}>Cancel</Button>
                <Button type="primary" onClick={this.checkListings}>
                  Next
                </Button>
              </div>
            </div>
          )}
          {step === 1 && (
            <div>
              <p>
                Suite Channels will now perform a series of checks to ensure
                your listings are ready to publish.
              </p>
              {errors.map(({ item, required }) => (
                <Alert
                  key={item.sku}
                  type="error"
                  message={
                    <span>
                      Item {item.sku} requires {required.join(', ')}
                    </span>
                  }
                />
              ))}
              {status === 'finish' && (
                <Alert type="success" message="Looks good!" />
              )}
              <div className="current-step__buttons">
                <Button
                  onClick={() => this.setState({ step: 0, status: 'wait' })}
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  disabled={status !== 'finish'}
                  onClick={this.publishListings}
                >
                  Publish
                </Button>
              </div>
            </div>
          )}
          {step === 2 && (
            <div>
              {status === 'process' && <span>Publishing..</span>}
              {status === 'error' && (
                <>
                  {this.state.apiErrors.map(error => (
                    <Alert key={error} type="error" message={error} />
                  ))}
                </>
              )}
              {status === 'finish' && (
                <>
                  <Alert
                    message="Listings Published"
                    description="It may take up to 15 minutes before your listings are reflected in the dashboard."
                    type="success"
                    showIcon
                  />
                  <div className="current-step__results">
                    <List
                      dataSource={this.state.apiInfo}
                      renderItem={item => <List.Item>{item}</List.Item>}
                    />
                  </div>
                </>
              )}
              <div className="current-step__buttons">
                <Button
                  type="primary"
                  disabled={status === 'process'}
                  onClick={onComplete}
                >
                  Finish
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}
